module.exports = __webpack_public_path__ + "static/media/design12.ff7bd2bb.png";